import { createFileRoute } from "@tanstack/react-router";
import AdminSurveyResponses from "@/pages/AdminSurveyResponses";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/survey-responses/")({
  head: () => ({ meta: [{ title: "Survey Responses | MavenWERX" }] }),
  component: () => (
    <RoleGate allow={['staff', 'viewer']} area="Survey Responses"><AdminSurveyResponses /></RoleGate>
  ),
});
